export default {
    en: {
        "订单自动取消": "Automatic cancellation of orders",
        "订单自动确认": "Order automatic confirmation",
        "订单售后时效": "Order after-sales timeliness",
        "售后自动驳回时效": "Automatic rejection time limit for after-sales service",
        "自动审批同意": "Automatic approval and consent",
        "未发货订单申请退款是否自动审批同意": "Is the refund request for unshipped orders automatically approved",
        "到店退货": "Store return",
        "启用后，请前往店铺管理中设置到店退货信息，消费者申请退货退款时可选择到店退货。":"After activation, please go to the store management to set up in store return information. Consumers can choose to return in store when applying for returns and refunds.",
        "微信小程序": "WeChat Mini Program",
        "PC网页版": "PC web version",
        "支付宝小程序": "Alipay applet",
        "商城": "mall",
        "该功能支持": "This feature supports",
        "备注信息": "Remarks",
        "我的图片": "My pictures",
        "我的视频": "My video",
        "此视频暂无法播放，请稍后再试": "This video cannot be played at the moment. Please try again later",
        "添加视频": "Add Video",
        "更换视频": "Replace video",
        "视频": "Video",
        "上传视频": "Upload video",
        "暂无数据": "no data",
        "上传视频只能是 mp4 格式!": "Uploading videos can only be in MP4 format!",
        "上传图片大小不能超过 50MB!": "The size of the uploaded image cannot exceed 50MB!",
        "视频本地上传": "Local video upload",
        "链接复制成功": "Link copied successfully",
        "轮播": "Carousel",
        "商品栅格": "Product Grid",
        "热区图": "Hot zone map",
        "优惠券": "Coupons",
        "橱窗": "Showcase window",
        "商品Tab": "Product Tab",
        "搜索": "Search",
        "文字标题": "Text title",
        "文字轮播": "Text rotation",
        "热点话题": "Hot topic",
        "商品滚动": "Product rolling",
        "楼层图片": "Floor image",
        "图片导航": "Image navigation",
        "页面设置": "Page Settings",
        "导航背景":"Navigation background",
        "页面标题": "Page Title",
        "标题位置":"Title Position",
        "页面背景": "Page background",
        "标题": "Title",
        "副标题": "Subtitle",
        "组件间距": "Component spacing",
        "热区设置": "Hot Zone Settings",
        "样式": "Style",
        "显示价格": "Display price",
        "显示品牌":"Display brand",
        "选择商品": "Select product",
        "查看更多": "View more",
        "轮播时间": "Rotation time",
        "圆角图片": "Rounded image",
        "指示点样式": "Indicator Point Style",
        "指示点覆盖": "Indicator point coverage",
        "指示点位置": "Indicating point position",
        "指示点形状": "Indicating point shape",
        "指示点颜色": "Indicator point color",
        "轮播项间距": "Rotation item spacing",
        "轮播项": "Carousel item",
        "建议尺寸:（宽度640px，高度自适应)": "Suggested size: (width 640px, height adaptive)",
        "添加": "Add",
        "选择路径": "Select path",
        "H5链接": "H5 Link",
        "重置": "Reset",
        "设置路径": "Set up path",
        "商品": "Product",
        "销售分类": "Sales classification",
        "店铺":"Shop",
        "管理分类": "Management classification",
        "商品标签": "Product labels",
        "文章": "Article",
        "软文": "native content",
        "页面": "Page",
        "营销": "Marketing",
        "活动报名": "Event registration",
        "秒杀": "Flash sale",
        "自定义页面": "Custom Page",
        "直播": "direct seeding",
        "外部小程序": "External Mini Program",
        "设置热区": "Set up hot zones",
        "选择图片": "Select image",
        "建议尺寸:（宽度640px，高度自适应）": "Suggested size: (width 640px, height adaptive)",
        "取消": "Cancel",
        "确定": "Confirm",
        "选择视频": "Select Video",
        "视频比例": "Video ratio",
        "优惠券名称": "Coupon Name",
        "展示图": "Display image",
        "券包": "Coupon package",
        "商品分类": "Product classification",
        "占位内容": "Placeholder content",
        "钉在顶部": "Nail on top",
        "文字位置": "Text position",
        "话题": "topic",
        "请填写自定义链接": "Please fill in the custom link",
        "限时特惠": "Limited time special offer",
        "单商品": "Single item",
        "秒杀活动": "Flash sale activity",
        "选择限时特惠": "Choose a limited time discount",
        "选择秒杀": "Choose flash sale",
        "选择秒杀活动":"Choose a flash sale activity",
        "选择限时特惠活动": "Choose a limited time special promotion",
        "内容": "content",
        "图片标题": "Image Title",
        "选择软文": "Select Soft Text",
        "显示背景图": "Display background image",
        "字体颜色": "Font color",
        "图片列表": "Image List",
        "导航项": "Navigation items",
        "保存": "preserve",
        "设置路径内容": "Set path content",
        "关键词之间请用半角”,”分隔":"Please separate the keywords with a half width",
        "建议尺寸:（宽度128px，高度自适应）": "Suggested size: (width 128px, height adaptive)",
        "提示: 优惠券、券包颜色跟随商城主题色变化": "Tip: The color of coupons and coupons will follow the theme color of the mall",
        "设置「更多」链接": "Set 'More' link",
        "设置「更多」图片": "Set 'More' Images",
        "提示": "prompt",
        "商品类型": "Product type",
         "开启排行榜": "Activate leaderboard",
         "更多链接": "More links",
         "更多图片": "More images",
         "页面路径": "Page path",
         "标题名称": "Title Name",
         "建议尺寸:（宽度130px，高度200px）": "Suggested dimensions: (width 130px, height 200px)",
         "选择店铺": "Select Store",
         "选择地区筛选店铺": "Select region to filter stores",
         "请输入店铺名称": "Please enter the store name",
         "店铺名称": "Store Name",
         "店铺类型": "Store type",
         "加盟": "Franchise",
         "自营": "Self operated",
         "店铺地址": "Store address",
         "AES密钥": "AES Key",
         "体积m³": "Volume m ³",
         "(企业邮箱)": "(Enterprise email)",
         "(企业电话)": "(Company Phone)",
         "*支付方式": "* Payment Method",
         "积分价格(积分)": "Point price (points)",
         "手机号": "Mobile phone number",
         "修改成功!": "Modified successfully!",
         "商户名称": "Merchant Name",
         "个体户":"Individual businesses",
         "企业": "enterprise",
         "重置密码": "reset password",
         "编辑": "edit",
         "超级管理员": "Super administrator",
         "手机号（账号名称）": "Phone number (account name)",
         "短信费用将从短信余额中扣除": "The SMS fee will be deducted from the SMS balance",
         "新密码将以短信形式发送至其手机号上": "The new password will be sent as a text message to their phone number",
         "请确认是否重置【商户名称】的密码": "Please confirm whether to reset the password for [Merchant Name]",
         "分账金额=(订单金额-手续费)*经销商分账占比，若计算金额存在三位及以上的小数，则四舍五入精确至两位小数": "Divided amount=(order amount - handling fee) * proportion of distributor's split. If there are three or more decimal places in the calculated amount, round it to the nearest two decimal places",
         "英文小程序唯一标识": "Unique identifier for English mini programs",
         "店铺分账金额=订单金额-手续费-总部分账金额-经销商分账金额": "Store distribution amount=Order amount - Handling fee - Headquarters distribution amount - Dealer distribution amount",
         "为用户的公众号开通开放平台账号并且绑定小程序/公众号，用于打通用户的小程序和公众号用户和卡券等数据。如果未授权，请手动开通微信开放平台并且绑定":"Open a platform account for the user's official account and bind the applet/official account to get through to the user's applet, official account, user, card and coupon and other data. If not authorized, please manually open the WeChat open platform and bind it."

    },
    zh: {
        "超级管理员":"超级管理员",
        "编辑":"编辑",
        "重置密码": "重置密码",
        "企业":"企业",
        "个体户": "个体户",
        "商户名称": "商户名称",
        "手机号（账号名称）": "手机号（账号名称）",
        "手机号":"手机号",
        "提示":"提示",
        "短信费用将从短信余额中扣除": "短信费用将从短信余额中扣除",
        "新密码将以短信形式发送至其手机号上": "新密码将以短信形式发送至其手机号上",
        "(企业邮箱)":"(企业邮箱)",
        "(企业电话)": "(企业电话)",
        "*支付方式": "*支付方式",
        "积分价格(积分)": "积分价格(积分)",
        "体积m³": "体积m³",
        "页面路径": "页面路径",
        "标题名称":"标题名称",
        "此视频暂无法播放，请稍后再试": "此视频暂无法播放，请稍后再试",
        "添加视频": "添加视频",
        "更换视频": "更换视频",
        "字体颜色": "字体颜色",
        "图片列表": "图片列表",
        "显示背景图": "显示背景图",
        "视频": "视频",
        "上传视频": "上传视频",
        "暂无数据": "暂无数据",
        "上传视频只能是 mp4 格式!": "上传视频只能是 mp4 格式!",
        "上传图片大小不能超过 50MB!": "上传图片大小不能超过 50MB!",
        "视频本地上传": "视频本地上传",
        "链接复制成功": "链接复制成功",
        "轮播": "轮播",
        "商品栅格": "商品栅格",
        "热区图": "热区图",
        "优惠券": "优惠券",
        "橱窗": "橱窗",
        "商品Tab": "商品Tab",
        "搜索":"搜索",
        "文字轮播": "文字轮播",
        "文字标题": "文字标题",
        "热点话题": "热点话题",
        "商品滚动": "商品滚动",
        "楼层图片": "楼层图片",
        "图片导航":"图片导航",
        "页面设置": "页面设置",
        "导航背景": "导航背景",
        "页面标题": "页面标题",
        "标题位置": "标题位置",
        "页面背景": "页面背景",
        "标题": "标题",
        "副标题": "副标题",
        "组件间距": "组件间距",
        "热区设置": "热区设置",
        "样式": "样式",
        "显示价格": "显示价格",
        "显示品牌": "显示品牌",
        "选择商品": "选择商品",
        "查看更多": "查看更多",
        "轮播时间": "轮播时间",
        "圆角图片": "圆角图片",
        "指示点样式": "指示点样式",
        "指示点覆盖": "指示点覆盖",
        "指示点位置": "指示点位置",
        "指示点形状": "指示点形状",
        "指示点颜色": "指示点颜色",
        "轮播项间距": "轮播项间距",
        "轮播项": "轮播项",
        "建议尺寸:（宽度640px，高度自适应)": "建议尺寸:（宽度640px，高度自适应)",
        "添加": "添加",
        "选择路径": "选择路径",
        "H5链接": "H5链接",
        "重置":"重置",
        "设置路径": "设置路径",
        "商品": "商品",
        "销售分类": "销售分类",
        "店铺":"店铺",
        "管理分类": "管理分类",
        "商品标签": "商品标签",
        "文章": "文章",
        "软文": "软文",
        "页面": "页面",
        "营销":"营销",
        "活动报名": "活动报名",
        "秒杀": "秒杀",
        "自定义页面": "自定义页面",
        "直播": "直播",
        "外部小程序": "外部小程序",
        "设置热区": "设置热区",
        "选择图片": "选择图片",
        "建议尺寸:（宽度640px，高度自适应）":"建议尺寸:（宽度640px，高度自适应）",
        "修改成功!": "修改成功!",
        "取消": "取消",
        "确定": "确定",
        "选择视频": "选择视频",
        "视频比例": "视频比例",
        "优惠券名称": "优惠券名称",
        "展示图": "展示图",
        "券包": "券包",
        "商品分类": "商品分类",
        "提示: 优惠券、券包颜色跟随商城主题色变化": "提示: 优惠券、券包颜色跟随商城主题色变化",
        "占位内容": "占位内容",
        "钉在顶部": "钉在顶部",
        "文字位置": "文字位置",
        "话题": "话题",
        "请填写自定义链接": "请填写自定义链接",
        "限时特惠": "限时特惠",
        "单商品": "单商品",
        "秒杀活动": "秒杀活动",
        "选择秒杀活动": "选择秒杀活动",
        "选择限时特惠": "选择限时特惠",
        "选择秒杀": "选择秒杀",
        "选择限时特惠活动": "选择限时特惠活动",
        "内容": "内容",
        "选择软文": "选择软文",
        "图片标题": "图片标题",
        "建议尺寸:（宽度128px，高度自适应）": "建议尺寸:（宽度128px，高度自适应）",
        "导航项": "导航项",
        "关键词之间请用半角”,”分隔":"关键词之间请用半角”,”分隔",
        "保存": "保存",
        "设置路径内容": "设置路径内容",
        "设置「更多」链接": "设置「更多」链接",
        "设置「更多」图片":"设置「更多」图片",
        "商品类型": "商品类型",
        "开启排行榜": "开启排行榜",
        "更多链接": "更多链接",
        "更多图片": "更多图片",
        "建议尺寸:（宽度130px，高度200px）": "建议尺寸:（宽度130px，高度200px）",
        "选择店铺":"选择店铺",
        "选择地区筛选店铺": "选择地区筛选店铺",
        "请输入店铺名称": "请输入店铺名称",
        "店铺名称": "店铺名称",
        "店铺类型": "店铺类型",
        "加盟": "加盟",
        "自营": "自营",
        "店铺地址": "店铺地址",
        "英文小程序唯一标识":"英文小程序唯一标识",
        "AES密钥": "AES密钥",
        "请确认是否重置【商户名称】的密码": "请确认是否重置【商户名称】的密码",
        "分账金额=(订单金额-手续费)*经销商分账占比，若计算金额存在三位及以上的小数，则四舍五入精确至两位小数":"分账金额=(订单金额-手续费)*经销商分账占比，若计算金额存在三位及以上的小数，则四舍五入精确至两位小数",
        "店铺分账金额=订单金额-手续费-总部分账金额-经销商分账金额":"店铺分账金额=订单金额-手续费-总部分账金额-经销商分账金额",
        "为用户的公众号开通开放平台账号并且绑定小程序/公众号，用于打通用户的小程序和公众号用户和卡券等数据。如果未授权，请手动开通微信开放平台并且绑定":"为用户的公众号开通开放平台账号并且绑定小程序/公众号，用于打通用户的小程序和公众号用户和卡券等数据。如果未授权，请手动开通微信开放平台并且绑定"
    }
}
